import m from "../../geodata/es2015/greeceHigh";
window.am4geodata_greeceHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/greeceHigh.js
// module id = null
// module chunks = 